import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import adminPromotionService from '../api/adminPromotionService';

const KEYS = {
    all: ['promotions'],
    detail: (id) => ['promotion', id]
};

export const usePromotions = () => {
    return useQuery({
        queryKey: KEYS.all,
        queryFn: () => adminPromotionService.getAll().then((res) => res.data),
        staleTime: 5 * 60 * 1000
    });
};

export const usePromotionDetail = (id) => {
    return useQuery({
        queryKey: KEYS.detail(id),
        queryFn: () => adminPromotionService.getById(id).then((res) => res.data),
        enabled: !!id,
        staleTime: 5 * 60 * 1000
    });
};

export const useCreatePromotion = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => adminPromotionService.create(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
        }
    });
};

export const useUpdatePromotion = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => adminPromotionService.update(id, payload),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
            queryClient.invalidateQueries({ queryKey: KEYS.detail(id) });
        }
    });
};
